<template>
  <div
    class="row"
    :class="{
      'programmatic_navigation': programmaticNavigation
    }"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'TableRow',
  props: {
    programmaticNavigation: {
      type: Boolean,
      default: false
    }
  }
}
</script>
